import { Menu, Icon } from 'ant-design-vue';
import './menu.less';

// 函数式组件直接返回菜单节点，保留任意深度的后端子菜单。
export default {
  functional: true,
  props: { nodes: { type: Array, required: true } },
  render(h, { props }) {
    const renderNodes = (nodes, depth = 0) => nodes.map((node) => {
      const data = {
        key: node.menuCode,
        class: 'cmhub-menu-node',
        style: { '--cmhub-menu-indent': `${24 + depth * 20}px` },
      };
      const title = [h('span', node.menuName)];
      if (['team', 'shop'].includes(node.icon)) title.unshift(h(Icon, { props: { type: node.icon } }));
      if (node.children && node.children.length) {
        return h(Menu.SubMenu, data, [
          h('span', { slot: 'title' }, title), ...renderNodes(node.children, depth + 1),
        ]);
      }
      return h(Menu.Item, data, title);
    });
    return renderNodes(props.nodes);
  },
};
